// Mock data pour le site BTP

export const companyInfo = {
  name: "SOGI",
  tagline: "Excellence en construction depuis 25 ans",
  description: "Votre partenaire de confiance pour tous vos projets de construction, du gros œuvre à la promotion immobilière.",
  phone: "+221 77 637 54 45",
  phone2: "+221 33 867 73 89",
  email: "gestion@sogi.sn",
  address: "Dakar, Sénégal",
  yearsExperience: 25,
  projectsCompleted: 100,
  clientsSatisfied: 100,
  employeesCount: 45,
  founder: "Abdoulaye DIARRA",
  founderTitle: "Ingénieur Génie Civil",
  foundedYear: 2000,
  founderExperience: 25
};

export const history = {
  title: "HISTORIQUE & VALEURS",
  story: "Fondée depuis les années 2000 par l'entrepreneur Abdoulaye DIARRA ingénieur génie civil, l'entreprise se développe rapidement dans le domaine du génie civil bâtiment. Avec plus de 25 ans d'expérience dans le métier, il a mis en place des méthodes de travail moderne pour mieux accompagner ses clients."
};

export const values = [
  {
    id: 1,
    title: "Qualité des prestations",
    description: "La qualité de ses prestations et de ses ouvrages",
    icon: "award"
  },
  {
    id: 2,
    title: "Respect des engagements",
    description: "La qualité d'écoute et le respect des engagements pris et contractualisés",
    icon: "handshake"
  },
  {
    id: 3,
    title: "Développement humain",
    description: "La formation et l'évolution des membres de l'entreprise (Confiance, Responsabilité, Épanouissement des salariés)",
    icon: "users"
  },
  {
    id: 4,
    title: "Rentabilité & Croissance",
    description: "La rentabilité, moteur essentiel du développement d'une PME",
    icon: "trending-up"
  },
  {
    id: 5,
    title: "Innovation permanente",
    description: "La flexibilité, la créativité et innovation permanente",
    icon: "lightbulb"
  }
];

export const services = [
  {
    id: 1,
    title: "Gros Œuvre",
    description: "Fondations, maçonnerie, charpente - nous réalisons tous les travaux structurels de votre projet avec expertise et rigueur.",
    icon: "building",
    features: [
      "Fondations et terrassement",
      "Maçonnerie et élévation",
      "Charpente traditionnelle et métallique",
      "Couverture et étanchéité"
    ],
    image: "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/pvfgf6xp_B8D6B5FE-825F-4CA8-9A84-8D96300F2BC2.jpg"
  },
  {
    id: 2,
    title: "Second Œuvre",
    description: "Finitions, aménagements intérieurs, installation - nous donnons vie à vos espaces avec qualité et savoir-faire.",
    icon: "hammer",
    features: [
      "Plâtrerie et isolation",
      "Menuiseries intérieures et extérieures",
      "Électricité et plomberie",
      "Revêtements et peinture"
    ],
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/l4m8py6p_IMG_5629.jpg"
  },
  {
    id: 3,
    title: "Promotion Immobilière",
    description: "Développement de projets résidentiels modernes avec vente en VEFA. Investissez dans la qualité et la tranquillité d'esprit.",
    icon: "home",
    features: [
      "Conception de projets résidentiels",
      "Vente en VEFA (Vente en l'État Futur d'Achèvement)",
      "Gestion complète du projet",
      "Garanties constructeur"
    ],
    image: "https://images.unsplash.com/photo-1519662978799-2f05096d3636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzY1MDQ1NjgwfDA&ixlib=rb-4.1.0&q=85"
  }
];

export const projects = [
  {
    id: 1,
    title: "BGFI BANK R+8",
    category: "Gros Œuvre",
    location: "Dakar",
    description: "Immeuble de bureaux moderne R+8 pour BGFI Bank. Construction structurelle complète avec finitions haut de gamme.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/ejffvhz4_IMG_1148.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/ejffvhz4_IMG_1148.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/xs46qqz8_IMG_1142.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/xrej9q0o_IMG_1143.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/g38ehinb_IMG_1144.jpg"
    ],
    year: "2015",
    status: "Terminé"
  },
  {
    id: 2,
    title: "Immeuble Thiargane R+9",
    category: "Gros Œuvre",
    location: "Dakar",
    description: "Tour résidentielle moderne de 9 étages avec vue panoramique. Structure en béton armé.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/ubwdlrar_Fichier00001.png",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/ubwdlrar_Fichier00001.png",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/lu7bq31d_Fichier00003.png",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/pmkcpndt_Fichier00004.png",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/6au1jtoo_Fichier00008.png",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/i2taat04_33200330_166468347363898_2732736202653302784_n.jpg"
    ],
    year: "2012",
    status: "Terminé"
  },
  {
    id: 3,
    title: "Résidence MADISA 2 BAT R+3",
    category: "Gros Œuvre",
    location: "Corniche Ouest, Dakar",
    description: "Ensemble résidentiel de 2 bâtiments R+3. Gros œuvre terminé avec structure en béton armé et fondations renforcées.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/apppblle_IMG_9751.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/apppblle_IMG_9751.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/1bexqdrg_IMG_9760.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/gis3z0lk_IMG_9761.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/be2gk21p_IMG_9769.jpg"
    ],
    year: "2016",
    status: "Terminé"
  },
  {
    id: 4,
    title: "R+7 SIPRES",
    category: "Gros Œuvre",
    location: "Dakar",
    description: "Immeuble de bureaux R+7 pour SIPRES. Construction moderne avec installations techniques avancées.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/m9w0w6f7_Fichier00022.png",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/m9w0w6f7_Fichier00022.png",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/a418cnwu_image.png",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/3oods9vo_image.png",
      "https://customer-assets.emergentagent.com/job_sogi-construction-2/artifacts/9mpkmqn9_33403284_166466880697378_2047188615380860928_n.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-2/artifacts/23cjf6gu_33173060_166467004030699_5695814400494010368_n%20%281%29.jpg"
    ],
    year: "2015",
    status: "Terminé"
  },
  {
    id: 5,
    title: "R+10 Aquanique Virage",
    category: "Gros Œuvre",
    location: "Virage, Dakar",
    description: "Tour résidentielle de 10 étages dans le quartier Virage. Structure moderne en béton armé avec fondations renforcées.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/pt0bzsng_WhatsApp%20Image%202025-12-07%20at%2014.34.03%20%283%29.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/xn1qtet1_IMG_5923.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/m982sb2l_IMG_5922.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/n7z6rv46_WhatsApp%20Image%202025-12-07%20at%2014.34.02.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/bo7z2f0j_WhatsApp%20Image%202025-12-07%20at%2014.34.02%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/oo3403xa_WhatsApp%20Image%202025-12-07%20at%2014.34.03.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/g08pdekr_WhatsApp%20Image%202025-12-07%20at%2014.34.03%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/n0mqom61_WhatsApp%20Image%202025-12-07%20at%2014.34.03%20%283%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/yud5rbry_IMG_7284.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/iv6vf6ac_IMG_7315.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/oy277rrj_IMG_7318.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/499wpq7f_IMG_7319.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/2pqhss99_IMG_7321.JPG"
    ],
    year: "2021",
    surface: "900 m²",
    status: "Terminé"
  },
  {
    id: 6,
    title: "Immeuble Locafrique",
    category: "Gros Œuvre",
    location: "Almadies, Dakar",
    description: "Siège social moderne avec architecture contemporaine et aménagements premium.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/nknsg7np_34396163_10214683528474832_8913612789239513088_n-1024x1024-700x700_c.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/nknsg7np_34396163_10214683528474832_8913612789239513088_n-1024x1024-700x700_c.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/ha28vt99_34437658_10214684462978194_5202094350607056896_n-1024x1024-700x700_c%20%281%29.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/8w404gql_34437658_10214684462978194_5202094350607056896_n-1024x1024-700x700_c.jpg"
    ],
    year: "2021",
    status: "Terminé"
  },
  {
    id: 7,
    title: "Villa Mme Maiga",
    category: "Gros Œuvre",
    location: "Almadies, Dakar",
    description: "Villa de standing. Gros œuvre terminé avec structure en béton armé et fondations de qualité.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/4mwgvrn9_20180503_134412.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/4mwgvrn9_20180503_134412.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/3e2cztwb_20180503_134458.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/9ex81p4t_20180503_134531.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/60gp4v0h_20180503_134552.jpg"
    ],
    year: "2022",
    surface: "200 m²",
    status: "Terminé"
  },
  {
    id: 8,
    title: "Sous-sol R+6 Ngor",
    category: "Gros Œuvre",
    location: "Ngor, Dakar",
    description: "Immeuble résidentiel avec sous-sol et 6 étages. Fondations renforcées et structure moderne.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/hgba982u_WhatsApp%20Image%202025-12-07%20at%2023.04.51.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/o0vosjc5_20190221_141152.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/luufb8zk_20190302_151015.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/39gywzlg_20190302_160047.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/cyx664jm_WhatsApp%20Image%202025-12-07%20at%2023.04.51.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/xstqu07i_WhatsApp%20Image%202025-12-07%20at%2023.04.49.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/cd23hqju_WhatsApp%20Image%202025-12-07%20at%2023.04.50.jpeg"
    ],
    year: "2021",
    surface: "600 m²",
    status: "Terminé"
  },
  {
    id: 9,
    title: "R+6 Almadies",
    category: "Gros Œuvre",
    location: "Almadies, Dakar",
    description: "Immeuble moderne de 6 étages dans le quartier résidentiel des Almadies.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/1vxublop_image.png",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/1vxublop_image.png",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/r4f90gc6_JBUS7566.JPG",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/2fpemp5l_81585613_446460146031382_6263571822478884864_n.jpg"
    ],
    year: "2021",
    surface: "500 m²",
    status: "Terminé"
  },
  {
    id: 10,
    title: "Sous-sol R+7 Liberté 5",
    category: "Gros Œuvre",
    location: "Liberté 5, Dakar",
    description: "Tour résidentielle avec parking sous-sol et 7 étages d'appartements standing.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/md1odpy8_IMG_2805.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/md1odpy8_IMG_2805.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/mpn5yc1s_WhatsApp%20Image%202025-12-08%20at%2000.19.02.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/a6di13by_WhatsApp%20Image%202025-12-08%20at%2000.19.03.jpeg"
    ],
    year: "2025",
    surface: "320 m²",
    status: "Terminé"
  },
  {
    id: 11,
    title: "Sous-sol R+9 Liberté 5",
    category: "Gros Œuvre",
    location: "Liberté 5, Dakar",
    description: "Tour résidentielle de standing avec sous-sol et 9 étages. Architecture moderne.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/kzkh6ex8_A467AD97-B939-43EE-A7D4-8D2D6FA61AB4.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/kzkh6ex8_A467AD97-B939-43EE-A7D4-8D2D6FA61AB4.jpg"
    ],
    year: "2025",
    surface: "320 m²",
    status: "Terminé"
  },
  {
    id: 12,
    title: "Résidence Pipe Diop R+5 Virage",
    category: "Promotion Immobilière",
    location: "Virage, Dakar",
    description: "Résidence moderne en VEFA avec 5 étages. Appartements de standing avec prestations de qualité.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/t8xo47el_4F5C2CE9-7ED5-41C5-95E7-420DBEF0B05F.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/t8xo47el_4F5C2CE9-7ED5-41C5-95E7-420DBEF0B05F.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-2/artifacts/djssitl0_WhatsApp%20Image%202025-12-09%20at%2004.26.41.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-2/artifacts/5zpy0k2y_IMG_6132.jpg"
    ],
    year: "2024",
    surface: "289 m²",
    status: "VEFA en cours"
  },
  {
    id: 13,
    title: "Sous-sol R+Mezzanine+10 Liberté 5",
    category: "Promotion Immobilière",
    location: "Liberté 5, Dakar",
    description: "Projet ambitieux en VEFA : sous-sol, mezzanine et 10 étages. Architecture innovante et prestations premium.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/q91s2vje_B73B4228-5778-44A7-B896-AAB8D0409495.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/q91s2vje_B73B4228-5778-44A7-B896-AAB8D0409495.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/trvcldad_85DFC5AC-D1D7-4C79-BCF9-B983D63C2909.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/pkcztaoa_f3ef5b6f-dd66-41c3-ae69-d42056eec254.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/1pkvv905_c6d549a0-1bbf-4c4d-ba27-7f32fd75e332.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/gttnrbyn_5C2C2244-8952-4EF0-A9A9-22AC90632477.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/b3my65m1_1129%20%281%29.mp4"
    ],
    year: "2024",
    surface: "320 m²",
    status: "VEFA en cours"
  },
  {
    id: 14,
    title: "Résidence Natoma R+8 Almadies",
    category: "Promotion Immobilière",
    location: "Almadies, Dakar",
    description: "Résidence de luxe en VEFA dans le prestigieux quartier des Almadies. Vue mer et prestations exceptionnelles.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/wot3hmbc_IMG_7419.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/w0hsn9yz_IMG_7434.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/3bv9jt8e_IMG_7420.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/ve7ynkde_A0D9360D-9823-4473-B241-B4D049FBEB31.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/5fywnce3_IMG_2017.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/54dbjigv_IMG_1891.jpg"
    ],
    year: "2024",
    surface: "295 m²",
    status: "VEFA en cours"
  },
  {
    id: 15,
    title: "R+5 Cité Mbackiyou Faye",
    category: "Gros Œuvre",
    location: "Cité Mbackiyou Faye, Dakar",
    description: "Immeuble résidentiel R+5 avec appartements modernes et équipements de qualité.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/hf4un70d_WhatsApp%20Image%202025-12-07%20at%2023.24.01.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/hf4un70d_WhatsApp%20Image%202025-12-07%20at%2023.24.01.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/r6zlra4t_WhatsApp%20Image%202025-12-07%20at%2023.24.01%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/tjkiu3q4_WhatsApp%20Image%202025-12-07%20at%2023.24.01%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/oiaojhm9_WhatsApp%20Image%202025-12-07%20at%2023.24.02.jpeg"
    ],
    year: "2022",
    surface: "200 m²",
    status: "Terminé"
  },
  {
    id: 16,
    title: "R+4 Cité Mbackiyou Faye",
    category: "Gros Œuvre",
    location: "Cité Mbackiyou Faye, Dakar",
    description: "Immeuble résidentiel R+4 dans un quartier en développement. Construction soignée et finitions de qualité.",
    image: "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/s0fx7sp5_DSCN4610%20copie%202.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/s0fx7sp5_DSCN4610%20copie%202.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/qos87jkl_DSCN4613.JPG",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/3q33au0h_EEF0C306-87F0-4014-9DFE-E3E15E9BA247.jpg",
      "https://customer-assets.emergentagent.com/job_4b762263-2925-4d82-9b7b-cea5b3813e84/artifacts/kfwxsevr_BA0C5AA6-BF95-481B-81A9-97F77C7A0360.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/im7sccrw_WhatsApp%20Image%202025-12-07%20at%2023.33.59.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/5xa39t2c_WhatsApp%20Image%202025-12-07%20at%2023.34.03%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction-1/artifacts/yumxqlw4_WhatsApp%20Image%202025-12-07%20at%2023.34.03%20%282%29.jpeg"
    ],
    year: "2022",
    surface: "300 m²",
    status: "Terminé"
  },
  {
    id: 17,
    title: "6 Hangars Diamniadio",
    category: "Gros Œuvre",
    location: "Diamniadio, Dakar",
    description: "Ensemble de 6 hangars industriels modernes à Diamniadio. Constructions robustes de 200 m² chacune, adaptées aux besoins logistiques et industriels.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/kea4pkpr_WhatsApp%20Image%202025-12-07%20at%2018.03.22.jpeg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/kea4pkpr_WhatsApp%20Image%202025-12-07%20at%2018.03.22.jpeg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/4u0nc24l_IMG_0315.MOV",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/8dguawos_72994579241__339525C9-7063-4D07-9877-D0DCB96AB59A.MOV"
    ],
    year: "2025",
    surface: "1,200 m²",
    status: "Terminé"
  },
  {
    id: 18,
    title: "R+4 Cité Damel",
    category: "Gros Œuvre",
    location: "Cité Damel, Dakar",
    description: "Immeuble résidentiel R+4 dans le quartier Cité Damel. Structure moderne en béton armé avec finitions de qualité.",
    image: "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/d0jnqkmy_IMG_0518.jpg",
    images: [
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/d0jnqkmy_IMG_0518.jpg",
      "https://customer-assets.emergentagent.com/job_sogi-construction/artifacts/52qxydi7_IMG_0520.jpg"
    ],
    year: "2023",
    surface: "236 m²",
    status: "Terminé"
  }
];

export const testimonials = [];

export const stats = [
  {
    number: "+100",
    label: "Projets réalisés",
    icon: "building-2"
  },
  {
    number: "25",
    label: "Ans d'expérience",
    icon: "award"
  },
  {
    number: "+100",
    label: "Clients satisfaits",
    icon: "users"
  }
];

export const advantages = [
  {
    title: "Expertise Reconnue",
    description: "Plus de 20 ans d'expérience dans tous les domaines du BTP, de la conception à la livraison.",
    icon: "shield-check"
  },
  {
    title: "Qualité Garantie",
    description: "Toutes nos réalisations respectent les normes les plus strictes avec garanties décennales.",
    icon: "badge-check"
  },
  {
    title: "Respect des Délais",
    description: "Planification rigoureuse et suivi quotidien pour une livraison dans les temps impartis.",
    icon: "clock"
  },
  {
    title: "Accompagnement Complet",
    description: "De l'étude de faisabilité à la réception des travaux, nous sommes à vos côtés à chaque étape.",
    icon: "handshake"
  }
];
